import { ATTENDANCE_ACTION_TYPES } from "./attendanceActionTypes";
import {
  AUTHENTICATE_THE_USER_FALSE,
  LOG_OUT,
} from "../accounts/accountActionsTypes";

export const emptyTodayActivity = () => ({
  events: [],
  segments: [],
  dayStartUtc: null,
  dayEndUtc: null,
  totalWorkedHours: null,
  overtimeHours: null,
  allowUsersToEditSubmittedEvents: false,
  allowUsersToDeleteSubmittedEvents: false,
  openCheckInSessionOnly: false,
  allowFlexibleWorkingWindow: false,
});

const initialState = {
  today: null,
  loading: true,
  error: null,
};

export default function attendanceReducer(state = initialState, action) {
  switch (action.type) {
    case ATTENDANCE_ACTION_TYPES.LOAD_TODAY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ATTENDANCE_ACTION_TYPES.LOAD_TODAY_SUCCESS:
    case ATTENDANCE_ACTION_TYPES.SET_TODAY_ACTIVITY:
      return {
        ...state,
        today: action.payload ?? emptyTodayActivity(),
        loading: false,
        error: null,
      };
    case ATTENDANCE_ACTION_TYPES.LOAD_TODAY_FAILURE:
      return {
        ...state,
        today: state.today ?? emptyTodayActivity(),
        loading: false,
        error: action.payload ?? null,
      };
    case LOG_OUT:
    case AUTHENTICATE_THE_USER_FALSE:
      return initialState;
    default:
      return state;
  }
}
